export default __webpack_public_path__ + "media/images/material-b4dedfcb0cae1b9bed0882b2a088fa8f.png";